import { Box, Button } from '@grupoboticario/flora-react'
import { useTranslation } from 'react-i18next'

type TProps = {
  type: string
  onChangeForm: (type: string) => void
}

const FormSwitcher = ({ type, onChangeForm }: TProps) => {
  const { t } = useTranslation()
  const handleSwitch = (typeFrom: string) => () => {
    onChangeForm(typeFrom)
  }

  const getVariant = (btnType: string) => (type === btnType ? 'standard' : 'ghost')

  return (
    <Box css={{ width: '100%' }}>
      <Button
        css={{ marginRight: '16px', fontWeight: '500' }}
        variant={getVariant('dispatcher')}
        size="large"
        onClick={handleSwitch('dispatcher')}
      >
        {t('dispatcherSignature')}
      </Button>

      <Button
        css={{ marginRight: '16px', fontWeight: '500' }}
        variant={getVariant('driver')}
        size="large"
        onClick={handleSwitch('driver')}
      >
        {t('shippingCompanySignature')}
      </Button>
    </Box>
  )
}

export default FormSwitcher
